import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Title, Image} from './../../Basics';

const Particle05 = () => (<div>

  <Title>Der Rollstuhl-Entwickler</Title>

   <Paragraph>
    Monatelang hat das das Team der Hochschule Rapperswil an einem treppensteigenden
    Rollstuhl getüftelt. Projektleiter Christian Bermes hat uns vor dem Wettkampf
    erzählt, was ihn und seine Kollegen antreibt.                   
  </Paragraph>
                          
  <Paragraph>
    <b>Christian, warum wollt ihr am Cybathlon dabei sein?</b>
    Ich fand zunächst die Idee eines solchen Wettkampfs spannend. Vorher hatte
    ich sehr wenig Kontakt zu Menschen mit körperlicher Behinderung. Aber durch
    unseren Piloten Florian Hauser sehe ich mittlerweile, welchen Hürden ihnen
    im Alltag begegnen. Sie zu bewältigen scheitert meist daran, dass es keine
    anständigen technischen Lösungen gibt. Ich möchte helfen, die Lebensqualität
    der Betroffenen zu verbessern.
  </Paragraph>

   <Image
    source={require('./christian-bermes.png')}
    title='Porträtfoto Christian Bermes'
    caption={<span>Christian Bermes ist Professor am Institut für Laborautomation und
    Mechatronik der Hochschule für Technik in Rapperswil. Foto: HSR</span>}
  />
   
  <Paragraph>
    <b>Bringt der Cybathlon die Entwicklung neuer Rollstühle voran?</b>
    Aus dem Wettkampf wird zwar nicht zwingend ein marktreifes Produkt herauskommen.
    Aber wir werden sehr interessante Teillösungen sehen, beispielsweise bei den
    Rollstühlen, die so wie unser Modell Treppen steigen können. Diese stellen
    heute immer noch ein unüberwindbares Hindernis für Rollstuhlfahrer dar.
  </Paragraph>

  <Particle
    number={9}
  />

  <Paragraph>
    <b>Warum gibt es bisher keine treppensteigenden Modelle zu kaufen?</b>

    Ich glaube nicht, dass es an der Technik scheitert. Aber eventuell ist der
    Markt zu klein, weshalb sich der grosse Aufwand in der Produktentwicklung
    für die Hersteller nicht lohnt.
  </Paragraph>


  <Image
    source={require('./04_Einzelteile_Bild_HSR.jpg')}
    title='Die Einzelzeile des treppensteigenden Rollstuhls'
    caption='Jetzt ist Zusammenbauen angesagt: Die Einzelteile des treppensteigenden Rollstuhls.'
  />
            
  <Paragraph>
    <b>Wie schätzt Du eure Chancen auf einen Sieg ein?</b>

    Nicht schlecht. Wir haben einen sehr mutigen Piloten, der bisher vor keinem
    Hindernis zurückgeschreckt ist und auch mal Vollgas geben kann. Aber Mut ist
    nicht alles. Gewinnen wird dasjenige Team, welches die beste Kombination aus
    Pilot und Technik hat. Denn das eine geht nicht ohne das andere. Ich glaube,
    dass unsere Technologie da einiges leisten kann. Zwar hat anfangs kaum jemand
    geglaubt, dass wir so weit kommen werden, weil wir erst letzten Dezember mit
    der Entwicklung begonnen haben. Das ist unfassbar wenig Zeit. Aber ich denke,
    dass wir trotzdem für ein paar Überraschungen sorgen werden.
  </Paragraph>

</div>);

export default Particle05;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle05/Particle05.js
 **/